import { useEffect, useState } from "react";

// Window-size guard per UX §16.7. Below 1280×800 the workstation density
// rules break; render a single message rather than a half-broken layout.

const MIN_W = 1280;
const MIN_H = 800;

const tooSmallNow = (): boolean =>
  window.innerWidth < MIN_W || window.innerHeight < MIN_H;

export const SizeGuard = () => {
  const [tooSmall, setTooSmall] = useState(tooSmallNow);

  useEffect(() => {
    const onResize = () => setTooSmall(tooSmallNow());
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  if (!tooSmall) {
    return null;
  }

  return (
    <div
      className="tp-size-guard"
      role="alert"
      aria-live="assertive"
    >
      <div className="msg">
        This app requires at least 1280 × 800. Resize your window.
      </div>
    </div>
  );
};
